import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import GlobalHeader from './GlobalHeader';
import { vehicleGroupService } from '../Services/vehicle.group.service';
import { menusService } from '../Services/menus.service';
import { useState, useEffect } from 'react';
import { Footer } from './Footer';

export default function NewLayout() {
  const { pageTitle } = useSelector(
    (rootReducer) => rootReducer.layoutDataReducer
  );
  const location = useLocation();
  const [optionVehicles, setOptionVehicles] = useState([]);
  const [menuLoaded, setMenuLoaded] = useState(false);

  // Verificar se é a página Home para mostrar filtros
  const isHomePage = location.pathname === '/home' || location.pathname === '/';

  // Carregar menu PRIMEIRO
  useEffect(() => {
    const loadMenu = async () => {
      try {
        await menusService.menus();
        setMenuLoaded(true);
      } catch (err) {
        console.error("Erro ao carregar menu:", err);
        setMenuLoaded(true);
      }
    };
    loadMenu();
  }, []);

  useEffect(() => {
    if (isHomePage && menuLoaded) {
      const fetchVehicleGroups = async () => {
        try {
          const responseGroups = await vehicleGroupService.fetchGroups();
          if (responseGroups) {
            const mappedGroups = responseGroups.map(group => ({
              groupVehicleId: group.vehicleGroupId,
              groupVehicleName: group.vehicleGroupName
            }));
            setOptionVehicles(mappedGroups);
          }
        } catch (err) {
          console.error("Erro ao buscar grupos de veículos:", err);
        }
      };
      fetchVehicleGroups();
    }
  }, [isHomePage, menuLoaded]);

  if (!menuLoaded) {
    return (
      <div className="movyx-layout">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <p>Carregando menu...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="movyx-layout">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="movyx-main">
        {/* Global Header */}
        <div className="movyx-navbar">
          <GlobalHeader 
            showFilters={isHomePage} 
            optionVehicles={optionVehicles}
          />
        </div>
                
        {/* Page Content */}
        <div className="movyx-content">
          <Outlet />
        </div>
        {/* <Footer /> */}

      </div>
    </div>
  );
}